import { Path } from '@trwl/shared/lib/router';
import { Button } from '@trwl/shared/ui/button';
import { BonusesTicketIcon } from '@trwl/shared/ui/icons';
import Image from 'next/image';
import Link from 'next/link';

export const ReferralBlock = () => {
  return (
    <div
      className={
        'grid grid-cols-1 md:grid-cols-2 w-full justify-between gap-8 overflow-hidden'
      }
    >
      <div className={'flex flex-col items-start justify-center gap-6'}>
        <div
          className={'font-normal leading-7 text-xl lg:text-3xl xl:leading-10'}
        >
          Отправляйте другу ссылку и <br />
          получите <b>1000 баллов</b> за его заказ
        </div>

        <div className={'relative'}>
          <Button
            as={Link}
            href={Path.BONUSES}
            size="lg"
            radius="sm"
            color="primary"
            className="whitespace-nowrap w-[220px] max-[400px]:w-[160px]"
          >
            Подробнее
          </Button>
          <BonusesTicketIcon
            className={
              'absolute -top-1 right-1 translate-x-full w-[160px] max-[400px]:w-[140px] md:w-[180px] lg:w-[220px] pointer-events-none'
            }
          />
        </div>
      </div>
      <div className={'flex justify-end'}>
        <Image
          width={500}
          height={600}
          src={
            'https://storage.yandexcloud.net/trwl-static/site/referral/referral.webp'
          }
          alt={'referralBlock'}
          className="w-2/3 sm:w-[300px] lg:w-[400px] xl:w-[500px] h-full"
          priority={true}
        />
      </div>
    </div>
  );
};
